import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const FuelChart = ({ data, unit }) => {
    const chartData = {
        labels: data.map(item => item.month),
        datasets: [
            {
                label: 'Fuel Expenses',
                data: data.map(item => item.total),
                fill: false,
                borderColor: 'rgba(75, 192, 192, 1)',
                tension: 0.1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: false,
                // text: 'Fuel Expenses',
            },
            tooltip: {
                mode: 'nearest',
                intersect: false, // Allows tooltip to appear without exact point click
                caretPadding: 10, // Adds 10px padding to shift tooltip away from cursor
                // backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent background
                // titleColor: '#000000', // Black title color for readability
                // bodyColor: '#000000', // Black body text color for readability
                // borderColor: 'rgba(0, 0, 0, 0)', // Transparent border
                borderWidth: 0, // No border
                displayColors: false, // Removes color box next to label
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: `Amount (${unit})`,
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Month',
                },
                grid: {
                    drawOnChartArea: false
                }
            },
        },
    };

    return (
        <div style={{ height: '300px', width: '100%' }}>
            <Line data={chartData} options={options} />
        </div>
    );
};

export default FuelChart;